import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	textWrapper: {
		minWidth: 0,
	},
	/** Sized for the longest option ("Do Not Collect") so the dropdown keeps one width across
	 *  selections instead of resizing the row on every change. */
	selectTrigger: {
		flexShrink: 0,
		width: 170,
	},
});
